import { useEffect, useState } from "react"
import { simpleGetter } from "../actions/common"
import { newUniversalApi, universalApi } from "../api/api"

const useUniversalFindAll = (model, triggerFetch) => {
    const [data, setData] = useState([])

    const fetchData = async () => {
        const response = await simpleGetter(universalApi.all, {
            model
        })
        if (response.list?.length) {
            setData(response.list)
        }
    }

    useEffect(() => {
        fetchData()
    }, [triggerFetch])

    return data
}

const useUniversalFind = (model, filters, params = {}, triggerFetch, postUpdate, resetOnFetch = false) => {
    const [data, setData] = useState([])

    const fetchData = async () => {
        if (resetOnFetch) {
            setData([])
        }
        const response = await simpleGetter(universalApi.find, {
            model,
            body: {
                filters,
                params
            }
        })
        if (Boolean(response.list)) {
            setData(response.list)
            if (postUpdate) {
                postUpdate(response.list);
            }
        }
    }

    useEffect(() => {
        fetchData()
    }, [triggerFetch])

    return data
}

const useNewUniversalFind = (model, filters, userParams = undefined, params = {}, triggerFetch, postUpdate, resetOnFetch = false) => {
    const [data, setData] = useState([])

    const fetchData = async () => {
        if (resetOnFetch) {
            setData([])
        }
        const response = await simpleGetter(newUniversalApi.find, {
            model,
            body: {
                filters,
                params,
                user_params: userParams
            }
        })
        if (Boolean(response.list)) {
            setData(response.list)
            if (postUpdate) {
                postUpdate(response.list);
            }
        }
    }

    useEffect(() => {
        fetchData()
    }, [triggerFetch])

    return data
}

export {
    useUniversalFindAll,
    useUniversalFind,
    useNewUniversalFind
}